{
    "status": {
        "inPrograming": "In programming",
        "planned": "Planned",
        "published": "Published",
        "canceled": "Canceled",
        "completed": "Finalized"
    },
    "format": {
        "standard": "Standard",
        "withoutDates": "Without dates",
        "onlyInfo": "Only info"
    },
    "soloInfoScope": {
        "all": "All",
        "onlyProgramming": "Only programming"
    },
    "priority": {
        "veryHigh": "Very high",
        "high": "High",
        "normal": "Normal",
        "low": "Low",
        "veryLow": "Very low"
    },
    "individualPayloadKeys": {
        "status": "Session status",
        "sessionFinishByAction": "Session close by action",
        "sessionFinishAt": "Session close by time",
        "eventSessionIndividualZones": "Capacity and prices",
        "merchandising": "Merchandising",
        "subtitle": "Website subtitle",
        "websiteAlert": "Website alert"
    },
    "ticketType": {
        "online": "Online",
        "ticketOffice": "Ticket office",
        "directAccess": "Direct access"
    },
    "ticketWindow": {
        "halfHourBefore": "Half an hour before the show",
        "oneHourBefore": "One hour before the show",
        "twoHourBefore": "Two hours before the show",
        "viewConditions": "View conditions",
        "other": "Other"
    },
    "ticketCodeType": {
        "automatic": "Automatic",
        "manual": "Manual - only codes",
        "many": "Manual - codes and associated tickets",
        "preGenerated": "Pre-generated"
    },
    "ticketCodeTypeDescription": {
        "automatic": "Default operation. QR codes are automatically generated when buying a ticket",
        "manual": "File with a list of codes. The number of codes must be equal to or greater than the reserved capacity for Subscription",
        "many": "File with a double list of data: codes and associated entries. The number of codes must be equal to or greater than the reserved capacity for Subscription",
        "preGenerated": "List of codes generated by the platform according to the following parameters"
    },
    "ticketFormat": {
        "pdf": "Email with attached PDF",
        "code": "Email with redeemable online code"
    },
    "ticketFormatDescription": {
        "pdf": "The attached PDF works as a digital ticket",
        "code": "The email contains a code and a link to redeem the code for a ticket"
    }
}
